import { render, staticRenderFns } from "./FractionsForm.vue?vue&type=template&id=18a35cf0&"
import script from "./FractionsForm.vue?vue&type=script&lang=js&"
export * from "./FractionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports